
//
// Properties of an accepted file
//
export class AcceptedFile {

    // Return the file
    public get file(): File {
        return this.acceptedFile;
    }

    // Constructs the object
    constructor(private acceptedFile: File) {
    }
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/ng2-file-drop/dropped-files/accepted-file.ts